// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1Mta8","slides":"styles_slides__1yTQx","slide":"styles_slide__1apZr","active":"styles_active__3UMWw"};